import React from 'react'
import './Header.css'
import { Link } from 'react-router-dom'
import SearchIcon from "@material-ui/icons/Search"
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket"
import { useStateValue } from '../StateProvider'
import { auth } from './Firebase'

function Header() {

    const [{ cart, user }] = useStateValue()

    const login = () => {
        if(user){
            auth.signOut()
        }
    }

    return (
        <nav className="header">
            <Link to = "/">
                    <img 
                    className ="header__logo" 
                    src = "http://pngimg.com/uploads/amazon/amazon_PNG11.png" 
                    alt ="" />
            </Link>


            <div className= 'header__search'>
                <input className="header__searchInput" type = "text" />
                <SearchIcon className="header__searchIcon"/>
            </div>
            

            <div className='headerNav'>
                
                <Link className = "header__link" to={ !user && "/login"}>
                    <div onClick={login} className="header__option">
                        <span 
                        className="header__optionLineOne"> 
                        Hello, {user?.email} </span>
                        <span className="header__optionLineTwo">
                        { user ? "Sign Out" : "Sign In" } </span>
                    </div>
                </Link>

                {/* <Link className = "header__link" to="/"> */}
                <a href = "https://www.amazon.in/gp/help/customer/display.html?nodeId=GNW5VKFXMF72FFMR" className="header__link">
                    <div className="header__option">
                        <span className="header__optionLineOne">
                        Returns </span>
                        <span className="header__optionLineTwo">
                         & Orders  </span>
                    </div>
                </a>    
                {/* </Link> */}

                {/* <Link className = "header__link" to="/"> */}
                <a className = "header__link" href="https://www.amazon.in/amazonprime?_encoding=UTF8&ascsubtag=_k_EAIaIQobChMIv_rD2qmT6wIVVLaWCh3UcQ-MEAAYASAAEgI4HvD_BwE_k_&ext_vrnc=hi&gclid=EAIaIQobChMIv_rD2qmT6wIVVLaWCh3UcQ-MEAAYASAAEgI4HvD_BwE&tag=googinkenshoo-21">
                    <div className="header__option">
                        <span className="header__optionLineOne">
                        Try  </span>
                        <span className="header__optionLineTwo">
                        Prime  </span>
                    </div>
                </a>    
                {/* </Link> */}

                <Link className = "header__link" to="/checkout">
                    <div className="header__optionBasket">
                        <ShoppingBasketIcon className="header__Basket" />
                        <span className="header__optionLineTwo header__BasketCount"> {cart.length} </span>
                    </div>
                </Link>


            </div>

        </nav>
    )
}

export default Header

// things in the navbar :-
// logo
// searchbox
// Sign in , Orders , Prime (Links)
// Cart logo